import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import CardSpacer from "@saleor/components/CardSpacer";
import CardTitle from "@saleor/components/CardTitle";
import { ControlledCheckbox } from "@saleor/components/ControlledCheckbox";
import Grid from "@saleor/components/Grid";
import S3TextField from "@saleor/components/S3TextField";
import { DiscountErrorFragment } from "@saleor/fragments/types/DiscountErrorFragment";
// import { commonMessages } from "@saleor/intl";
import { getFormErrors } from "@saleor/utils/errors";
import getDiscountErrorMessage from "@saleor/utils/errors/discounts";
import React from "react";
import { useIntl } from "react-intl";

interface DiscountSuperPriceProps {
  data: {
    onlyBuyOne: boolean;
    superName: string;
    superPriceText: string;
    superPriceImage: string;
    superPriceImageMb: string;
    showSuperPrice: boolean;
    showOriginalPrice: boolean;
  };
  defaultCurrency: string;
  disabled: boolean;
  errors: DiscountErrorFragment[];
  onChange: (event: React.ChangeEvent<any>) => void;
  setNameValue: (name, value) => void;
}

const DiscountSuperPrice = ({
  data,
  disabled,
  errors,
  onChange,
  setNameValue
}: DiscountSuperPriceProps) => {
  const intl = useIntl();

  const formErrors = getFormErrors(
    ["superName", "superPriceText", "superPriceImage", "superPriceImageMb"],
    errors
  );

  return (
    <Card>
      <CardTitle
        title={intl.formatMessage({
          defaultMessage: "Custom Sale Settings",
          description: "Price header during discount"
        })}
      />
      <CardContent>
        <ControlledCheckbox
          checked={data.onlyBuyOne}
          label={intl.formatMessage({
            defaultMessage: "Limit purchase of one product",
            description: "just only buy one"
          })}
          name={"onlyBuyOne" as keyof FormData}
          onChange={onChange}
        />
        <CardSpacer />
        <ControlledCheckbox
          checked={data.showSuperPrice}
          label={intl.formatMessage({
            defaultMessage: "Show Super Price",
            description: "voucher end date, switch button"
          })}
          name={"showSuperPrice" as keyof FormData}
          onChange={onChange}
        />
        <CardSpacer />
        {data.showSuperPrice && (
          <Grid variant="uniform">
            <TextField
              disabled={disabled}
              error={!!formErrors.superName}
              helperText={getDiscountErrorMessage(formErrors.superName, intl)}
              name={"superName" as keyof FormData}
              onChange={onChange}
              label={intl.formatMessage({
                defaultMessage: "Super Name",
                description: "Super Name"
              })}
              value={data.superName}
              fullWidth
            />
            <CardSpacer />
            <TextField
              disabled={disabled}
              error={!!formErrors.superPriceText}
              helperText={getDiscountErrorMessage(
                formErrors.superPriceText,
                intl
              )}
              name={"superPriceText" as keyof FormData}
              onChange={onChange}
              label={intl.formatMessage({
                defaultMessage: "Super Price Text",
                description: "Super Price Text"
              })}
              value={data.superPriceText}
              fullWidth
            />
            <CardSpacer />
            {/* <TextField
              disabled={disabled}
              error={!!formErrors.superPriceImage}
              helperText={getDiscountErrorMessage(
                formErrors.superPriceImage,
                intl
              )}
              name={"superPriceImage" as keyof FormData}
              onChange={onChange}
              label={intl.formatMessage({
                defaultMessage: "Background Image Url PC",
                description: "Background Image Url"
              })}
              value={data.superPriceImage}
              fullWidth
            /> */}
            <S3TextField
              disabled={disabled}
              error={!!formErrors.superPriceImage}
              helperText={getDiscountErrorMessage(
                formErrors.superPriceImage,
                intl
              )}
              name={"superPriceImage"}
              onChange={onChange}
              label={intl.formatMessage({
                defaultMessage: "Background Image Url PC",
                description: "Background Image Url"
              })}
              value={data.superPriceImage}
              setNameValue={setNameValue}
            />
            <CardSpacer />
            {/* <TextField
              disabled={disabled}
              error={!!formErrors.superPriceImageMb}
              helperText={getDiscountErrorMessage(
                formErrors.superPriceImageMb,
                intl
              )}
              name={"superPriceImageMb" as keyof FormData}
              onChange={onChange}
              label={intl.formatMessage({
                defaultMessage: "Background Image Url MB",
                description: "Background Image Url"
              })}
              value={data.superPriceImageMb}
              fullWidth
            /> */}

            <S3TextField
              disabled={disabled}
              error={!!formErrors.superPriceImageMb}
              helperText={getDiscountErrorMessage(
                formErrors.superPriceImageMb,
                intl
              )}
              name={"superPriceImageMb"}
              onChange={onChange}
              label={intl.formatMessage({
                defaultMessage: "Background Image Url MB",
                description: "Background Image Url"
              })}
              value={data.superPriceImageMb}
              setNameValue={setNameValue}
            />

            <CardSpacer />
            <ControlledCheckbox
              checked={data.showOriginalPrice}
              label={intl.formatMessage({
                defaultMessage: "Show Original Price",
                description: "Show Original Price"
              })}
              name={"showOriginalPrice" as keyof FormData}
              onChange={onChange}
            />
          </Grid>
        )}
      </CardContent>
    </Card>
  );
};
export default DiscountSuperPrice;
